export const ResetPasswordWasSent = () => {
    return <div className="confirmation__block">
        <p className="confirmation__message"> На ваш адрес электронной почты отправлено письмо для восстановление
            пароля</p>
    </div>
}